<template>
    <div class="application-loader">
        <v-progress-circular :indeterminate="true" size="50" v-if="!user_loaded"></v-progress-circular>
    </div>
</template>

<script>
    import {userService} from "../services";
    import Store from '../store/index'

    export default {
        name: "ConfirmInProgress",
        created() {
            userService.confirmEmail(this.$route.params['confirm_code']).then(
                data => {
                    if (data.section ==  'RECPASS'){
                        Store.commit('auth/setConfirmCode', this.$route.params['confirm_code']);
                        this.$router.push('/novo-geslo/');
                    } else if (data.section == 'NEWACC'){
                        Store.commit('auth/setConfirmCode', this.$route.params['confirm_code']);
                        this.$router.push('/ustvari/privolitve');
                    } else if (data.section == 'INVCRACC'){
                        Store.commit('auth/setConfirmCode', this.$route.params['confirm_code']);
                        Store.commit('auth/setConfirmCodeOtherData', data.other);
                        this.$router.push('/ustvari/kartica/izbrana');
                    } else if (data.section == 'INVCROACC'){
                        Store.dispatch('auth/me', {
                            redirectTo: '/ustvari/privolitve'
                        });
                    }else {
                        Store.commit('auth/setConfirmCode', undefined);
                        this.$router.push('/');
                    }
                },
                error => {
                    console.log(error);
                    Store.commit('auth/setConfirmCode', undefined);
                    this.$router.push('/login');
                }
            );
        }
    }
</script>

<style scoped>

</style>